module.exports = __webpack_public_path__ + "img/rx_qms_logo.fc63c7de.png";